import React from 'react';

import Button from '../../../button/button';
import ScanTireButton from '../scan-tire-button/scan-tire-button';

import { useMediaQuery } from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';

import './fitment-sub-tabs.scss';

export interface Tab {
  ariaControls: string;
  description: string;
}

interface FitmentSubTabsProps {
  className?: string;
  hideTabs?: boolean;
  onTabSelect?: (tab: Tab) => void;
  onTireScanned?: (tireWidth, selectedTireCrossDimension, tireDiameter) => void;
  selectedTab?: Tab;
  showScanner?: boolean;
  tabs: Tab[];
}

function FitmentSubTabs(props: FitmentSubTabsProps) {
  const {
    className = '',
    hideTabs = false,
    onTabSelect,
    onTireScanned,
    selectedTab,
    showScanner = false,
    tabs
  } = props;
  const { isMinLg } = useMediaQuery();

  return (
    <div
      className={`fitment-sub-tabs ${className}`}
      role="tablist"
      styleName="container"
    >
      {!hideTabs && (
        <div styleName="button-container">
          {Array.isArray(tabs) &&
            tabs.map((tab, idx) => (
              <Button
                aria-controls={tab.ariaControls}
                aria-selected={selectedTab === tab}
                id={`tab-${tab.description.toLowerCase()}`}
                key={idx}
                onClick={() => {
                  if (selectedTab !== tab) {
                    onTabSelect?.(tab);
                  }
                }}
                role="tab"
                size="regular"
                styleName={selectedTab === tab ? 'tab-selected' : 'tab'}
              >
                {tab.description.toLowerCase()}
              </Button>
            ))}
        </div>
      )}

      {!isMinLg && showScanner && (
        <ScanTireButton
          onClick={() => {
            if (process.env.__FF_TIRE_SCAN_OCR_REDESIGN__ === 'true') {
              const prefix = hideTabs ? 'vehicle' : 'size';
              trackAction(`shop_${prefix}_tire_scan_sidewall_click`);
            }
          }}
          onTireScanned={onTireScanned}
        />
      )}
    </div>
  );
}

export default FitmentSubTabs;
